import { Component } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
	selector: 'authentication-issue-page',
	templateUrl: './authentication-issue-page.component.html',
	imports: [TranslateDirective]
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AuthenticationIssuePageComponent {
	
}
